import { render, staticRenderFns } from "./CenterViewEventCreate_Ap.vue?vue&type=template&id=daa5a178&scoped=true"
import script from "./CenterViewEventCreate_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventCreate_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventCreate_Ap.vue?vue&type=style&index=0&id=daa5a178&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa5a178",
  null
  
)

export default component.exports